export { Image, createIcon, Icon } from "@chakra-ui/react";
const baseStyle = {
    w: '24px',
    h: '24px'
};
export const ThemedIcon = {
    baseStyle
};
export * from "./Cover/index";
export * from "./Carousel/index";
export * from "./Thumbnail/index";
export * from "./Avatar/index";

//# sourceMappingURL=index.js.map